class ProductGallery extends HTMLElement {
  connectedCallback() {
    if (this.events && !this.events.signal.aborted) return;
    this.events = new AbortController();
    const options = { signal: this.events.signal };
    this.photos = [...this.querySelectorAll('[data-photo-index]')];
    this.dialog = this.querySelector('dialog');
    this.frame = this.querySelector('[data-photo-frame]');
    this.counter = this.querySelector('[data-photo-counter]');
    this.status = this.querySelector('[data-photo-status]');
    this.dialog.toggleAttribute('data-single-photo', this.photos.length === 1);
    for (const button of this.querySelectorAll('[data-photo-previous], [data-photo-next]')) button.hidden = this.photos.length < 2;
    this.addEventListener('click', event => {
      const photo = event.target.closest('[data-photo-index]');
      if (photo) {
        this.opener = photo;
        if (!this.dialog.open) {
          this.dialog.showModal();
          this.previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          this.locked = true;
        }
        this.showPhoto(Number(photo.dataset.photoIndex));
      } else if (event.target.closest('[data-photo-close]')) this.closeViewer();
      else if (event.target.closest('[data-photo-previous]')) this.showPhoto(this.index - 1);
      else if (event.target.closest('[data-photo-next]')) this.showPhoto(this.index + 1);
      else if (event.target === this.dialog) {
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.closeViewer();
      }
    }, options);
    this.dialog.addEventListener('keydown', event => {
      if (event.key === 'Tab') {
        const buttons = [...this.dialog.querySelectorAll('button:not([hidden]):not(:disabled)')];
        const first = buttons[0];
        const last = buttons[buttons.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        event.stopPropagation();
        this.showPhoto(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }
    }, options);
    this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.closeViewer(); }, options);
    this.dialog.addEventListener('close', () => {
      if (!this.dialog.open && this.locked) this.cleanup();
    }, options);
  }

  showPhoto(index) {
    this.index = (index + this.photos.length) % this.photos.length;
    const photo = this.photos[this.index];
    const image = new Image();
    this.image = image;
    image.alt = photo.dataset.photoAlt;
    image.hidden = true;
    image.addEventListener('load', () => {
      if (this.image !== image || !this.dialog.open) return;
      image.hidden = false;
      this.status.textContent = '';
    }, { once: true });
    image.addEventListener('error', () => {
      if (this.image === image && this.dialog.open) this.status.textContent = this.status.dataset.photoErrorCopy;
    }, { once: true });
    this.frame.replaceChildren(image);
    this.counter.textContent = this.counter.dataset.template.replace('[current]', String(this.index + 1)).replace('[total]', String(this.photos.length));
    this.status.textContent = this.status.dataset.photoLoadingCopy;
    image.src = photo.dataset.photoSrc;
  }

  releaseScroll() {
    if (!this.locked) return;
    document.documentElement.style.overflow = this.previousOverflow;
    this.locked = false;
  }

  closeViewer() {
    this.dialog.close();
    this.cleanup();
  }

  cleanup() {
    this.releaseScroll();
    this.image = null;
    this.frame.replaceChildren();
    if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
  }

  disconnectedCallback() {
    if (this.dialog?.open) this.dialog.close();
    this.releaseScroll();
    this.image = null;
    this.events?.abort();
  }
}

if (!customElements.get('hnl-product-gallery')) customElements.define('hnl-product-gallery', ProductGallery);
